<template>
  <span data-testid="history-page">
    <plan-gate service="history" />
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card>
      <v-card-title>
        <h4>{{ $t("home.events") }}</h4>
        <v-spacer></v-spacer>
        <div :class="'pulse mt-3 mx-2 ' + (connected ? 'pulse_success' : 'pulse_error')
          " v-tooltip="{
            content: connected
              ? $t('custom.connected')
              : $t('custom.disconnected'),
            placement: 'bottom-center',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }"></div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <v-flex>
          <v-text-field v-model="search" class="mb-2" append-icon="mdi-magnify" :label="$t('custom.search')" single-line
            clearable hide-details hide-no-data></v-text-field>
        </v-flex>
        <v-data-table :items="operations" :headers="headers" :loading="isLoadingSearch" :items-per-page="20"
          :loading-text="$t('custom.loading_table')" :class="!isMobile ? '' : 'is-mobile'" :search="search"
          :server-items-length.sync="total" :options.sync="tableOptions" :page.sync="page" item-key="id"
          mobile-breakpoint="100" :footer-props="tableFooterProps([20, 50, 100])">
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-no-wrap">
                {{ formatCreatedAt(props.item.created_at) }}
              </td>
              <td>{{ props.item.description }}</td>
            </tr>
          </template>
          <template slot="no-data">
            {{ $t("custom.no_data_in_table") }}
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            {{ $t("tables.no_search_result", { msg: search }) }}
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import CableSubscriber from "@/mixins/CableSubscriber";
export default {
  mixins: [CableSubscriber],
  pullToRefresh: true,
  data() {
    return {
      subscribedCompanyId: null, // ID компании для отписки от канала
      operations: [],
      headers: [
        {
          text: this.$i18n.t("custom.date"),
          sortable: false,
          value: "created_at",
          class: "text-xs-center",
        },
        {
          text: this.$i18n.t("custom.description"),
          sortable: false,
          value: "description",
          class: "text-xs-center",
        },
      ],
      search: null,
      page: 1,
      per_page: 50,
      sort_by: "id",
      direction: "desc",
      tableOptions: { sortDesc: [true] }, // дефолт сортировки; :sort-desc на таблице стоять НЕ должен
      total: 0,
      timeout: null,
      // Номер последнего запроса ленты: ответ на устаревший запрос не перетирает свежий.
      operationsRequestId: 0,
      isMobile: false,
      isLoading: false,
      isLoadingSubscribeToPaidTariff: false,
      isLoadingSearch: false,
      connected: false,
      error: "",
    };
  },
  mounted() {
    // Сохраняем ID для безопасной отписки
    this.subscribedCompanyId = this.$store.getters.getCompany.company.id;
    // FT-066: native held-ref subscription; handlers via arrows (this-rebinding). Mixin
    // auto-unsubscribes in beforeDestroy. Bodies moved 1:1 into on*-methods below.
    this.operationsSub = this.$cableSubscribe(
      { channel: "OperationsChannel", room: this.subscribedCompanyId },
      {
        connected: () => this.onOperationsConnected(),
        disconnected: () => this.onOperationsDisconnected(),
        received: (data) => this.onOperationsReceived(data),
      }
    );
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.isAdminPlus) {
        this.loadOperations();
      } else {
        this.$router.push({ path: `/dashboard` }).catch((err) => { });
        this.$notify(this.$t("errors.only_admins"), "", "warning", 3000);
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  beforeDestroy() {
    // FT-066: CableSubscriber mixin auto-unsubscribes the held ref. Explicit drop kept for clarity.
    this.$cableUnsubscribe(this.operationsSub);
    this.operationsSub = null;
  },
  watch: {
    tableOptions(pagination) {
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage;
      this.sort_by = pagination.sortBy[0] ? pagination.sortBy[0] : "id";
      this.direction = pagination.sortDesc[0] ? "desc" : "asc";
      this.loadOperations();
    },
    search() {
      if (this.search == "" || this.search == " ") {
        this.search = null;
      } else {
        if (this.timeout) clearTimeout(this.timeout);
        // Любая правка поля делает запросы в полёте устаревшими: их ответ выдачу не меняет.
        this.operationsRequestId += 1;
        this.isLoadingSearch = false;
        // FT-213: по одному символу не ищем — совпадений тысячи, и индекс тут не помогает.
        // Отложенный запрос снят выше, иначе при стирании до одной буквы ушёл бы прежний.
        if (this.search && this.search.trim().length === 1) return;
        this.timeout = setTimeout(() => this.loadOperations(), 400);
      }
    },
  },
  computed: {
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else if (!this.$store.getters.getMainCompany.plan.trial_end && this.$store.getters.getMainCompany.created_at) {
              return moment(this.$store.getters.getMainCompany.created_at).isBefore(moment().subtract(7, "day")) ? true : false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
  },
  methods: {
    // FT-066: OperationsChannel handlers (moved 1:1 from the old declarative channel).
    onOperationsConnected() {
      console.log("connected");
      this.connected = "success";
    },
    onOperationsDisconnected() {
      console.log("disconnected");
      this.connected = "error";
    },
    onOperationsReceived(data) {
      if (data.action == "create") {
        console.log("create");
        this.operations.unshift(data.operation);
      }
      if (data.action == "update") {
        // Ищем индекс элемента в массиве
        let index = this.operations.findIndex((operation) => operation.id == data.operation.id);
        // Если элемент найден
        if (index != -1) {
          // Заменяем элемент в массиве
          this.operations.splice(index, 1, data.operation);
        }
      }
      if (data.action == "destroy") {
        console.log("destroy");
        this.operations.splice(
          this.operations.findIndex((operation) => operation.id == data.operation_id),
          1
        );
      }
    },
    loadOperations() {
      const requestId = ++this.operationsRequestId;
      // Один символ — как пустой поиск (см. watch search).
      const search = this.search && this.search.trim().length > 1 ? this.search : null;
      this.isLoadingSearch = true;
      this.axios
        .post(
          `/api/v1/search_operations`,
          {
            page: this.page,
            per_page: this.per_page,
            sort_by: this.sort_by,
            direction: this.direction,
            search: search,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          if (requestId !== this.operationsRequestId) return;
          this.operations = [];
          response.data.operations.data.forEach((operation) => {
            this.operations.push(operation.attributes);
          });
          this.total = response.data.total_operations;
        })
        .catch((error) => {
          if (requestId !== this.operationsRequestId) return;
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => {
          if (requestId === this.operationsRequestId) this.isLoadingSearch = false;
        });
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM YY H:mm");
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath,
          })
          .catch((err) => { });
      }
    },
  },
};
</script>
<style></style>
